export * from './projekt-arts.page';
export * from './projekt-arts.page.resolver';
